import React, { useState } from 'react';
import { Send, MessageSquare, Mail, Loader2, Star } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { toast } from 'sonner';
import { API } from '@/utils/api';
import axios from 'axios';

const WoDirectMessage = ({ clientId, clientName, woReference, woId }) => {
  const [open, setOpen] = useState(false);
  const [channel, setChannel] = useState('whatsapp');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sendingSurvey, setSendingSurvey] = useState(false);

  const handleSendSurvey = async () => {
    setSendingSurvey(true);
    try {
      const res = await axios.post(`${API}/satisfaction/send-to-client/${clientId}`, { work_order_id: woId || '' });
      if (res.data.success) {
        toast.success(`Enquete envoyee par ${res.data.channel === 'whatsapp' ? 'WhatsApp' : 'Email'}`);
      } else {
        toast.error('Echec envoi enquete');
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur');
    } finally { setSendingSurvey(false); }
  };

  const handleSend = async () => {
    if (!message.trim()) return;
    setSending(true);
    try {
      const res = await axios.post(`${API}/clients/${clientId}/send-message`, {
        channel,
        message: message.trim(),
        subject: `Fiche ${woReference} - Message de votre garage`,
      });
      if (res.data.success) {
        if (res.data.whatsapp_url && channel === 'whatsapp' && res.data.method === 'fallback_link') {
          window.open(res.data.whatsapp_url, '_blank');
          toast.success('WhatsApp Web ouvert');
        } else {
          toast.success(`Message envoye a ${clientName}`);
        }
        setMessage('');
        setOpen(false);
      } else {
        toast.error(res.data.error || 'Echec envoi');
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur envoi');
    } finally { setSending(false); }
  };

  if (!open) {
    return (
      <Card className="p-3 rounded-xl flex items-center gap-2 flex-wrap" data-testid="wo-direct-message">
        <Button variant="outline" size="sm" onClick={() => setOpen(true)} className="text-xs" data-testid="open-direct-msg">
          <MessageSquare className="w-3.5 h-3.5 mr-1" /> Message a {clientName || 'client'}
        </Button>
        <Button variant="outline" size="sm" onClick={handleSendSurvey} disabled={sendingSurvey} className="text-xs" data-testid="wo-send-survey">
          {sendingSurvey ? <Loader2 className="w-3 h-3 mr-1 animate-spin" /> : <Star className="w-3 h-3 mr-1 text-amber-500" />}
          Enquete satisfaction
        </Button>
      </Card>
    );
  }

  return (
    <Card className="p-4 rounded-xl space-y-3" data-testid="wo-direct-message-form">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-bold text-slate-900">Message a {clientName}</h3>
        <div className="flex gap-1">
          <Button size="sm" variant={channel === 'whatsapp' ? 'default' : 'outline'}
            onClick={() => setChannel('whatsapp')}
            className={`text-xs h-7 ${channel === 'whatsapp' ? 'bg-green-600 hover:bg-green-700' : ''}`}>
            <MessageSquare className="w-3 h-3 mr-1" /> WhatsApp
          </Button>
          <Button size="sm" variant={channel === 'email' ? 'default' : 'outline'}
            onClick={() => setChannel('email')}
            className={`text-xs h-7 ${channel === 'email' ? 'bg-blue-600 hover:bg-blue-700' : ''}`}>
            <Mail className="w-3 h-3 mr-1" /> Email
          </Button>
        </div>
      </div>
      <Textarea value={message} onChange={e => setMessage(e.target.value)} placeholder="Votre message..." rows={3} data-testid="wo-msg-input" />
      <div className="flex gap-2 justify-end">
        <Button variant="ghost" size="sm" onClick={() => setOpen(false)}>Annuler</Button>
        <Button size="sm" onClick={handleSend} disabled={sending || !message.trim()} className="bg-slate-800" data-testid="wo-send-msg">
          {sending ? <Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" /> : <Send className="w-3.5 h-3.5 mr-1" />}
          Envoyer
        </Button>
      </div>
    </Card>
  );
};

export default WoDirectMessage;
